import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { captureException } from 'raven-js';
import { useDataFetchingClient } from 'data-fetching-client';
import Log from 'forms-utils-lib/logger/Logger';

// @ts-expect-error untyped dependency
import { saveFormError } from 'FormsUI/actions/FormSaving';
// @ts-expect-error untyped dependency
import { FormErrors } from 'FormsUI/api/Forms';
// @ts-expect-error untyped dependency
import { getFormGuid } from 'FormsUI/selectors/FormDefinition';
import { GET_DRAFT_ROUTING_QUERY } from '../../../../__generated__/chirp/com/hubspot/forms/routing/rpc/LegacyFormsRoutingService.dfc.new';
import { useUpdateDraftRoutingMutation } from '../../../../__generated__/chirp/com/hubspot/forms/routing/rpc/LegacyFormsRoutingService.hooks';
const useUpsertRouting = () => {
  const dispatch = useDispatch();
  const formGuid = useSelector(getFormGuid);
  const client = useDataFetchingClient();
  const [updateDraftRouting, {
    loading,
    error
  }] = useUpdateDraftRoutingMutation();
  const updateRouting = useCallback(async updatedRouting => {
    try {
      const response = await updateDraftRouting({
        variables: {
          formRouting: updatedRouting
        }
      });
      if (response.data) {
        client.writeQuery({
          query: GET_DRAFT_ROUTING_QUERY,
          variables: {
            formId: formGuid
          },
          data: {
            result: response.data.result
          }
        });
      }
    } catch (err) {
      Log.error('Failed to upsert forms routing', {
        error: err
      });
      if (err instanceof Error) {
        captureException(err);
      } else {
        captureException(new Error('Unknown error during routing update', {
          cause: err
        }));
      }
      dispatch(saveFormError(FormErrors.UNKNOWN));
    }
  }, [updateDraftRouting, client, formGuid, dispatch]);
  return {
    updateRouting,
    loading,
    error
  };
};
export default useUpsertRouting;